import React from "react";

function truncateLabel(value, maxLength) {
  if (!value || value.length <= maxLength) return value;
  return `${value.slice(0, Math.max(0, maxLength - 1)).trimEnd()}…`;
}

function AnalyticsRankedAxisTick({ x, y, payload, maxLength = 24, fontSize = 11.5 }) {
  const fullLabel = payload?.value || "";
  const displayLabel = truncateLabel(fullLabel, maxLength);

  return (
    <g transform={`translate(${x},${y})`}>
      <title>{fullLabel}</title>
      <text
        x={0}
        y={0}
        dy={4}
        textAnchor="end"
        style={{ fill: "var(--theme-text-muted, #64748b)", fontSize, fontWeight: 500 }}
      >
        {displayLabel}
      </text>
    </g>
  );
}

export default AnalyticsRankedAxisTick;
